import { IconButton } from '@mgh-app/component-library';
import { AddIcon } from 'components/Icons';
import { ReactNode } from 'react';
import {
  backgroundColor,
  borderRadius,
  combineCls,
  display,
  dropShadow,
  fontSize,
  height,
  lineHeight,
  margin,
  overflow,
  padding,
  textAlign,
  textColor,
  textOverflow,
  twCls,
  width,
} from 'style';

export interface NewPresetButtonProps {
  className?: string;
  children?: ReactNode;
  onClick?: () => void;
}

export const NewPresetButton = ({
  children,
  className,
  onClick,
}: NewPresetButtonProps): JSX.Element => {
  return (
    <IconButton
      onClick={onClick}
      className={combineCls(
        twCls(
          width('w-20'),
          height('h-11'),
          borderRadius('rounded-xl'),
          backgroundColor('bg-white', 'hover:bg-white'),
          dropShadow('drop-shadow-home'),
          margin('m-2'),
          padding('px-2', 'pb-1', 'pt-2'),
          display('flex'),
        ),
        className,
      )}
    >
      <AddIcon />
      <div
        className={combineCls(
          twCls(
            margin('ml-1'),
            textColor('text-grey-900'),
            textAlign('text-left'),
            textOverflow('text-ellipsis'),
            fontSize('text-xs'),
            lineHeight('leading-tight'),
            overflow('overflow-hidden'),
          ),
          'text-multiline-ellipsis',
        )}
      >
        {children}
      </div>
    </IconButton>
  );
};
